// SEAA = Science, Engineering, Athletics, Arts. Content sourced from lpfoundation.world.
// Colors aligned to the LP Foundation logo palette (blue, teal, green, purple, orange, navy).
export const PROGRAMS = [
  {
    slug: "krypto-kids",
    name: "Krypto Kids",
    pillar: "Science",
    color: "#2563EB",
    tag: "Digital Finance & Emerging Technology",
    short: "Foundations of digital currency, blockchain concepts, and responsible financial thinking — in an age-appropriate format.",
    image: "/img/krypto.jpeg",
    filter: "brightness(1.32) contrast(1.04) saturate(1.06)",
    description:
      "Students explore the foundations of digital currency, blockchain concepts, and responsible financial thinking in an age-appropriate format. Through applied projects, young people build real understanding of the tools and ideas shaping tomorrow's economy.",
    outcomes: ["Financial literacy", "Critical thinking", "Digital responsibility", "Confidence in emerging technologies"],
  },
  {
    slug: "beats",
    name: "Beats, Rhythms & Kids",
    pillar: "Arts",
    color: "#7C3AED",
    tag: "Music Production & Audio Engineering",
    short: "Rhythm, beat-making, sound design, and creative production using real-world tools and structured instruction.",
    image: "/img/beats.jpeg",
    filter: "brightness(1.18) contrast(1.03) saturate(1.05)",
    description:
      "Students learn rhythm, beat-making, sound design, and creative production using real-world tools and structured instruction. Music becomes a pathway to discipline, collaboration, and applied learning.",
    outcomes: ["Pattern recognition", "Creative discipline", "Collaboration skills", "Applied math through tempo & timing"],
  },
  {
    slug: "flight-club",
    name: "Flight Club",
    pillar: "Engineering",
    color: "#14B8A6",
    tag: "Drone Technology & Aviation Systems",
    short: "Hands-on experience with drone operations, aviation principles, and structured safety protocols.",
    image: "/img/flight.jpeg",
    fit: "contain",
    description:
      "Students gain hands-on experience with drone operations, aviation principles, and structured safety protocols. Flight Club blends excitement with engineering discipline to keep youth focused and forward-looking.",
    outcomes: ["Flight distance & navigation", "Aerodynamics fundamentals", "Aviation history", "Focus & safety discipline"],
  },
  {
    slug: "cinemagic-kids",
    name: "CineMagic Kids",
    pillar: "Arts",
    color: "#22C55E",
    tag: "Film Production & Digital Media",
    short: "Foundations of storytelling, filming, editing, and production in a structured creative environment.",
    image: "/img/cinemagic.jpeg",
    filter: "brightness(1.08) contrast(1.02)",
    description:
      "Students learn the foundations of storytelling, filming, editing, and production in a structured creative environment. From script to screen, they discover the power of media to communicate and create.",
    outcomes: ["Communication skills", "Script writing & journaling", "Technical production knowledge", "Team collaboration"],
  },
  {
    slug: "design-district",
    name: "Design District",
    pillar: "Arts",
    color: "#F97316",
    tag: "Clothing Design & Creative Brand Development",
    short: "Design, create, and develop clothing pieces while learning the fundamentals of fashion production and branding.",
    image: "/img/design.jpg",
    description:
      "Students design, create, and develop clothing pieces while learning the fundamentals of fashion production and branding. Creativity meets entrepreneurship as students bring their ideas to life.",
    outcomes: ["Design thinking", "Creative problem-solving", "Communication & presentation skills", "Applied math through measurement & construction"],
  },
  {
    slug: "performance-readiness",
    name: "Performance Readiness",
    pillar: "Athletics",
    color: "#1E40AF",
    tag: "Focus, Discipline & Workforce Confidence",
    short: "The foundation of every LP program — ensuring students are focused, prepared, and ready to engage.",
    image: "/img/performance.jpeg",
    fit: "contain",
    description:
      "Every LP Foundation program begins with structured performance readiness to ensure students are focused, prepared, and ready to engage. Preparation leads to stronger performance — in learning and in life.",
    outcomes: ["Focus", "Self-discipline", "Communication", "Teamwork", "Confidence"],
  },
];

export const PILLARS = [
  { key: "Science", color: "#2563EB", label: "Science", blurb: "Digital finance, technology & emerging tools." },
  { key: "Engineering", color: "#14B8A6", label: "Engineering", blurb: "Drones, aviation systems & applied problem-solving." },
  { key: "Athletics", color: "#22C55E", label: "Athletics", blurb: "Performance readiness, focus & discipline." },
  { key: "Arts", color: "#7C3AED", label: "Arts", blurb: "Music, film, and clothing design & branding." },
];
